module.exports = __webpack_public_path__ + "static/media/cao-hac-sam-120gr-daedong.eab7dcb7.jpg";